import { useModules } from '@contexts/modules-provider';
import { useOrganizations } from '@contexts/organizations-provider';
import { useHasPermission } from '@contexts/permissions-provider';
import { DocumentsContent } from '@features/documents/components/documents-content/DocumentsContent';
import { DocumentsHeader } from '@features/documents/components/documents-header/DocumentsHeader';
import { DocumentsSearchView } from '@features/documents/components/documents-search-view/DocumentsSearchView';
import * as React from 'react';

import styles from './CaeDocumentsPage.module.css';

const CaeDocumentsPage = React.memo((): React.ReactElement => {
  const { selectedModule } = useModules();
  const { selectedOrganization } = useOrganizations();
  const canDownload = useHasPermission('CAETrainingDocuments_Open_All');
  const [isSearchActive, setIsSearchActive] = React.useState(false);

  const organizationId =
    selectedModule?.name === 'Manage'
      ? selectedOrganization?.id
      : undefined;

  const handleSearchActivate = React.useCallback((): void => {
    setIsSearchActive(true);
  }, []);

  const handleSearchBack = React.useCallback((): void => {
    setIsSearchActive(false);
  }, []);

  if (isSearchActive) {
    return (
      <DocumentsSearchView
        title="Search"
        documentType="CAEPublicDocument"
        organizationId={organizationId}
        canDownload={canDownload}
        onBack={handleSearchBack}
      />
    );
  }

  return (
    <div data-testid="cae-documents-page" className={styles.caeDocumentsPage}>
      <DocumentsHeader
        title="CAE documents"
        onSearchActivate={handleSearchActivate}
      />
      <DocumentsContent
        documentType="CAEPublicDocument"
        organizationId={organizationId}
        canDownload={canDownload}
        rootLabel="CAE documents"
      />
    </div>
  );
});

CaeDocumentsPage.displayName = 'CaeDocumentsPage';

export { CaeDocumentsPage };
